import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Route } from 'react-router';
import { Redirect, useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _hsq: { push: (callParam: any) => void };
    hsConversationsSettings: any;
  }
}

function PrivateRoute({ component: Component, ...children }: any): JSX.Element {
  const user = useSelector((state: any) => state.user);
  const location = useLocation();

  useEffect(() => {
    if (user.id !== 0) {
      try {
        window._hsq.push(['setPath', location.pathname]);
        window._hsq.push(['trackPageView']);
      } catch (error) {
        console.log('hsq private route', error);
      }
    }
  }, [location]);

  if (user.id !== 0) {
    return <Route {...children} render={(props) => <Component {...props} />} />;
  }
  return <Redirect to="/sign-in" />;
}

export default PrivateRoute;
